/*  ========================================================================
    # Scripts - Job Finder
    ========================================================================  */

/**
 * Script that handles the job finder functionality.
 */
const JobFinder = {
  cfg: {
    finderElement: document.querySelector('.s-job-finder'),
    finderFormElement: document.querySelector('.s-job-finder .s-job-finder__selects')
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.finderElement && this.cfg.finderFormElement) {
      this.cfg.finderFormElement.addEventListener('submit', e => {
        e.preventDefault();

        const formData = new FormData(this.cfg.finderFormElement);
        const locationValue = formData.get('location');
        const workingWorldValue = formData.get('working_world');

        const baseLink = this.cfg.finderFormElement.getAttribute('data-link');
        const url = new URL(baseLink);

        if (locationValue && locationValue !== 'all') {
          url.searchParams.append('location', locationValue);
        }

        if (workingWorldValue && workingWorldValue !== 'all') {
          url.searchParams.append('working_world', workingWorldValue);
        }

        window.location.href = url.toString();
      });
    }
  }
};

export default JobFinder;
